import { Select } from '@mui/material';
import { styled } from '@mui/material/styles';

/** Select that, when `locked`, shows a not-allowed cursor and hides the dropdown arrow. */
export const LockableSelect = styled(Select, {
  shouldForwardProp: prop => prop !== 'locked',
})<{ locked?: boolean }>(({ locked = false }) => ({
  cursor: locked ? 'not-allowed' : 'pointer',
  '& .MuiInputBase-input': { cursor: locked ? 'not-allowed' : 'pointer' },
  '& .MuiSelect-icon': { display: locked ? 'none' : 'initial' },
}));
